import { render } from "./Education.vue?vue&type=template&id=67804a24&scoped=true"
import script from "./Education.vue?vue&type=script&lang=js"
export * from "./Education.vue?vue&type=script&lang=js"

import "../style/buildingDevelopment.scss?vue&type=style&index=0&id=67804a24&lang=scss&scoped=true&external"
import "../style/common.scss?vue&type=style&index=1&id=67804a24&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67804a24"]])

export default __exports__